import { render, staticRenderFns } from "./vahaxmas.vue?vue&type=template&id=459d2438&scoped=true&"
import script from "./vahaxmas.vue?vue&type=script&lang=js&"
export * from "./vahaxmas.vue?vue&type=script&lang=js&"
import style0 from "./vahaxmas.vue?vue&type=style&index=0&id=459d2438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459d2438",
  null
  
)

export default component.exports